import { makeObservable } from "./Observable";

export const couponCodeContext = makeObservable();
